import { faFacebook } from "@fortawesome/free-brands-svg-icons/faFacebook";
import { faInstagram } from "@fortawesome/free-brands-svg-icons/faInstagram";
import { faLinkedin } from "@fortawesome/free-brands-svg-icons/faLinkedin";
import { faTwitter } from "@fortawesome/free-brands-svg-icons/faTwitter";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Grid } from '@mui/material';
import MuiAvatar from 'components/MuiExtras/MuiAvatar';
import MuiContainer from 'components/MuiExtras/MuiContainer';
import MuiWidgetTitle from 'components/MuiExtras/MuiWidgetTitle';
import { UserSocialNetworkType } from 'models/ApiEnums';
import { UserSocialNetworkModel } from 'models/ApiModels';
import * as React from 'react';
import { WithTranslation, withTranslation } from "react-i18next";

/////////////////////////////////////////////////////////////////////////////////////////////////////////////

interface IState {
}

interface IProps {
    socialNetworks: UserSocialNetworkModel[];
}

type Props = IProps & WithTranslation;

/////////////////////////////////////////////////////////////////////////////////////////////////////////////

class WidgetSocialNetworks extends React.PureComponent<Props, IState> {

    private renderNetwork(network: UserSocialNetworkModel) {

        var icon = network.networkName == UserSocialNetworkType[UserSocialNetworkType.Facebook]
            ? faFacebook
            : network.networkName == UserSocialNetworkType[UserSocialNetworkType.Instagram]
                ? faInstagram
                : network.networkName == UserSocialNetworkType[UserSocialNetworkType.Linkedin]
                    ? faLinkedin
                    : faTwitter;

        var title = network.networkName == UserSocialNetworkType[UserSocialNetworkType.Facebook]
            ? "Facebook"
            : network.networkName == UserSocialNetworkType[UserSocialNetworkType.Instagram]
                ? "Instagram"
                : network.networkName == UserSocialNetworkType[UserSocialNetworkType.Linkedin]
                    ? "LinkedIn"
                    : "Twitter";

        var url = network.networkName == UserSocialNetworkType[UserSocialNetworkType.Facebook]
            ? `http://www.facebook.com/${network.value}`
            : network.networkName == UserSocialNetworkType[UserSocialNetworkType.Instagram]
                ? `http://www.instagram.com/${network.value}`
                : network.networkName == UserSocialNetworkType[UserSocialNetworkType.Linkedin]
                    ? `http://br.linkedin.com/in/${network.value}`
                    : `https://twitter.com/${network.value}`;

        return (
            <Grid item>
                <a href={url} title={title} target="_blank"><MuiAvatar backgroundColor="info" ><FontAwesomeIcon icon={icon} /></MuiAvatar></a>
            </Grid>
        );
    }

    public render() {

        if (this.props.socialNetworks == null || this.props.socialNetworks.length == 0)
            return null;

        const data = this.props.socialNetworks.filter(p => p.value != null && p.value != "");
        if (data.length == 0)
            return null;

        return (
            <MuiContainer margin="normal" >
                <MuiWidgetTitle title={this.props.t("Views.User.Widgets.SocialNetworks.BoxTitle")} />
                <Grid container alignItems={"baseline"} spacing={1}>
                    {
                        data.map((v) => this.renderNetwork(v))
                    }
                </Grid>
                <br/>
            </MuiContainer >
        );
    }
}

export default withTranslation()(WidgetSocialNetworks);